import axios from 'axios'
import { useProfileStore } from '@/stores/profileStore'
import { incrementRequests, decrementRequests } from '@/composables/loadingState'
import { useToast } from '@/composables/useToast'
import router from '@/router'
const { showError } = useToast()

axios.defaults.baseURL = "/api"
// axios.defaults.timeout = 10000

axios.defaults.headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'access-control-allow-origin': '*'
}

axios.interceptors.request.use(
  (config) => {
    incrementRequests()
    const dataProfile = useProfileStore()
    if (dataProfile.logined) {
      config.headers.Authorization = `Bearer ${dataProfile.profile.jwtToken}`
    } else {
      delete config.headers.Authorization
    }
    return config
  },
  (error) => {
    decrementRequests()
    showError('خطا در ارسال درخواست به سرور.')
    return Promise.reject(error)
  },
)

axios.interceptors.response.use(
  (response) => {
    decrementRequests()
    return response
  },
  (error) => {
    decrementRequests()
    if (error.response) {
      if (error.response.status === 401) {
        showError('شما احراز هویت نشده‌اید یا نشست شما منقضی شده است.')
        router.push({ name: 'login', query: { last: router.currentRoute.value.fullPath } });
      } else if (error.response.status === 403) {
        showError('شما اجازه دسترسی به این منبع را ندارید.')
      } else if (error.response.status >= 500) {
        showError('مشکلی در سرور پیش آمده است. لطفا بعدا تلاش کنید.')
      } else if (error.response.data && error.response.data.message) {
        showError(`خطا: ${error.response.data.message}`)
      } else {
        showError(`خطایی رخ داد: ${error.response.status}`)
      }
    } else if (error.request) {
      showError('خطا در شبکه. لطفا اتصال اینترنت خود را بررسی کنید.')
    } else {
      showError('خطای ناشناخته در برنامه.')
    }
    return Promise.reject(error)
  },
)
